import { ImageMedia, LivestreamMedia } from '../../types/graphql';

export function isImageMedia<T extends ImageMedia>(node: any): node is T {
  return node && node.__typename === 'ImageMedia';
}

export function isLivestreamMedia(node: any): node is LivestreamMedia {
  return node && node.__typename === 'LivestreamMedia';
}
